// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3IQXm","naviBarBox":"index-naviBarBox-32Xmp","pageItem":"index-pageItem-TRCSQ"};